/**
 * Einblenden beim Scrollen.
 * Bewusst sehr zurueckhaltend: 8px Versatz, einmalig, kein Parallax.
 *
 * Ein Element wird sichtbar geschaltet, sobald seine Oberkante in den Blick
 * gescrollt ist — oder bereits darueber liegt. Geprueft bei Initialisierung
 * und bei jedem Scroll/Resize/Load. Dadurch bleibt KEIN abschliessender
 * Abschnitt haengen, auch nicht bei schnellem Scrollen bis ans Seitenende
 * (der Grund fuer zuvor unsichtbare Methodik-/Kooperationen-Bloecke).
 *
 * Faellt sauber zurueck: bei reduzierter Bewegung wird sofort alles sichtbar.
 */
(function () {
  "use strict";

  var elemente = [].slice.call(document.querySelectorAll(".einblenden"));
  if (!elemente.length) return;

  var zeigen = function (el) {
    // Gestaffeltes Erscheinen innerhalb einer Gruppe, maximal 5 Stufen.
    var stufe = Number(el.getAttribute("data-stufe") || 0);
    el.style.transitionDelay = Math.min(stufe, 5) * 70 + "ms";
    el.classList.add("ist-sichtbar");
  };

  var wenigerBewegung = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (wenigerBewegung.matches) {
    for (var i = 0; i < elemente.length; i++) elemente[i].classList.add("ist-sichtbar");
    return;
  }

  var offen = elemente;

  var pruefen = function () {
    if (!offen.length) return;
    // Ausloese-Linie 8% ueber der Unterkante: Element gilt als "im Blick",
    // sobald seine Oberkante darueber liegt (top wird beim Weiterscrollen negativ).
    var grenze = window.innerHeight * 0.92;
    var rest = [];
    for (var i = 0; i < offen.length; i++) {
      var el = offen[i];
      if (el.getBoundingClientRect().top < grenze) {
        zeigen(el);
      } else {
        rest.push(el);
      }
    }
    offen = rest;
    if (!offen.length) {
      window.removeEventListener("scroll", pruefen);
      window.removeEventListener("resize", pruefen);
    }
  };

  // Direkt an Scroll/Resize gebunden (kein rAF-Coalescing): so wird auch bei
  // sehr schnellem Scrollen bis ans Seitenende jede Position geprueft und kein
  // Abschnitt uebersprungen. Die Liste `offen` schrumpft, die Pruefung bleibt
  // guenstig; sobald alles sichtbar ist, entfernen sich die Listener selbst.
  window.addEventListener("scroll", pruefen, { passive: true });
  window.addEventListener("resize", pruefen, { passive: true });
  window.addEventListener("load", pruefen);
  pruefen(); // above-the-fold sofort sichtbar

  // Sicherheitsnetz: sollte durch extremes Timing (sehr schnelles Scrollen)
  // ein Abschnitt nicht ausgeloest worden sein, wird nach kurzer Zeit garantiert
  // alles sichtbar geschaltet. So bleibt NIEMALS ein leerer Abschnitt zurueck —
  // auch nicht der abschliessende Methodik-/Kooperationen-Block.
  window.setTimeout(function () {
    for (var i = 0; i < offen.length; i++) offen[i].classList.add("ist-sichtbar");
    offen = [];
    window.removeEventListener("scroll", pruefen);
    window.removeEventListener("resize", pruefen);
  }, 2000);
})();
